import { useEffect, useState } from 'react';

/** Re-render every `intervalMs` so relative timestamps stay accurate. */
export function useNowTick(intervalMs = 60_000) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
